import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import _ from 'lodash';
export default function GatewayDomainsInfoComponent ({handleFormDomainsItemChange,domains}: any) {
  return (
    <>
      <div className="h-[500px] overflow-auto w-full bg-white p-4">
        <table className="w-full text-xs bg-red-50">
          <thead className="w-full border-y border-black border-opacity-20">
            <tr className="w-full text-left h-12">
              <th className="border-r-2  last:border-r-0 w-auto px-10">Domain</th>
              <th className="border-r-2  last:border-r-0 w-auto px-10">Network</th>
              <th className="border-r-2  last:border-r-0 w-auto px-10">CoreVersion</th>
              <th className="border-r-2  last:border-r-0 w-auto px-10">Status</th>
            </tr>
          </thead>
          <tbody className="w-full bg-red-400 h-[400px]">
            {_.map(domains,(cardValue: any, index: any) => (
              <tr key={index} className="w-full cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
               
                  <td 
                  className="px-6 py-4  w-auto">
                   <InputContainer
        isDisabled
      name="Domain"
      onValueChange={(event: any) => {
        handleFormDomainsItemChange({
          value: event.target.value,
          field: 'Domain',
          idx: index
        });
      } }
      type="text"
      value={cardValue?.Domain} />             
                  </td>
                  <td 
                  className="px-6 py-4  w-auto">
                  <InputContainer
                     isDisabled
  
      name="Network"
      onValueChange={(event: any) => {
        handleFormDomainsItemChange({
          value: event.target.value,
          field: 'Network',
          idx: index
        });
      } }
      type="text"
      value={cardValue?.Network} />
                  </td>
                  <td 
                  className="px-6 py-4  w-auto">
                  <InputContainer
     isDisabled
                                    name="CoreVersion"
                                    onValueChange={(event: any) => {
                                      handleFormDomainsItemChange({
                                        value: event.target.value,
                                        field: 'CoreVersion',
                                        idx: index
                                      });
                                    } }
                                    type="text"
                                    value={cardValue?.CoreVersion} />
                  </td>
                  <td 
                  className="px-6 py-4  w-auto">
                  <InputContainer
     isDisabled
      name="Status"
      onValueChange={(event: any) => {
        handleFormDomainsItemChange({
          value: event.target.value,
          field: 'Status',
          idx: index
        });
      } }
      type="text"
      value={cardValue.Status} />
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
        </>
  )
}